import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const PopupContent = styled.div`
    color: #202124;
    opacity: 1;
    font-family: 'AvenirNextWorld Regular';
    font-size: 14px;
    width: ${(props) => props.width};
    height: 465px;
    margin-top: 18px;
    ${media.mobileDevice`
        margin-top:31.75px;
        color: #000000;
`}
`;
export const AddSignatureContent = styled.div`
    width: 711px;
    height: 60px;
    color: #202124;
    text-align: left;
    font-size: 14px;
    line-height: 20px
    font: Avenir Next World Regular;
    letter-spacing: 0px;
    opacity: 1;
    margin-bottom:27px;
    line-height: 18px;
    ${media.mobileDevice`
        width: 100%;
        height: auto;
    `}
`;
export const PopUpFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    ${media.mobileDevice`
        margin-top: -80px;  
        margin-right: 0px  !important;
        justify-content: space-between; 
    `}
    ${media.exSmallDevice`
        margin-top: -70px !important;  
    `}

    ${media.smalDevice`
        // margin-top: 60px;
       // margin-right: 40px 
    `}
`;

export const Buttons = styled.button`
border-radius: 25px;
width: 140px;
height: 38px;
padding: 5px;
background: white;
color: ${({ buttonColor }) => buttonColor};
margin-right : ${({ marginRight }) => (marginRight ? marginRight : 'unset')};
cursor:pointer;
border : 1px solid #140F4B;
font-family: AvenirNextWorld Demi;
font-size: 15px;
${(props) =>
    props.isClear &&
    `margin-left:0px;
    margin-right:16px;
border: 1px solid #1010EB;
color: #1010EB;
`}
${(props) =>
    props.isApply &&
    `
    width:162px;
background: #1010EB;
border: 1px solid #1010EB;
color: white;

`}
${(props) =>
    props.disabled &&
    `
background: #00000029;
border: 1px solid #00000029;
color: #888888;
`}
${media.mobileDevice`
        width: 90%;    
        width: 102px;
        ${(props) =>
            props.isApply &&
            `
            background: #1010EB;
            border: 1px solid #1010EB;
            color: white;
            width: 136px;
            height: 38px;
            font-size: 15px;
        `}
        ${(props) =>
            props.isClear &&
            `
            border: 1px solid #140F4B;
            color: #140F4B;
        `}
        ${(props) =>
            props.disabled &&
            `
            background: grey;
            border: 1px solid grey;
            color: white;
    `}
`}

}
`;

export const SignatureContainer = styled.div`
    border: 2px solid #ebeded;
    margin: 27px 0;
    background: #ffffff;
    height: ${({ containerHeight }) =>
        containerHeight ? containerHeight : '250px'};
    border-radius: 6px;
    ${media.mobileDevice`
        width: 100%;    
        height: ${({ mbContainerHeight }) =>
            mbContainerHeight ? mbContainerHeight : '100%'};
        margin: 0 auto;
        margin-top: 24px;
    `}
`;

export const SignatureApply = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 15px;
    margin-top: 14px;
`;

export const SignatureDate = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    margin-top: 8px;
`;

export const SignatureWrapper = styled.div`
    align-items: ${({ isDeskwithoutPriceOverRide }) =>
        isDeskwithoutPriceOverRide ? 'flex-start' : 'flex-end'};
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        ${({ withoutPriceOverride }) =>
            withoutPriceOverride &&
            `
                align-items: flex-start;
                > button {
                    margin-bottom: 0;
                }
            `}
    `}
`;

export const SignatureMessageContainer = styled.div`
    align-self: ${({ isDeskwithoutPriceOverRide }) =>
        isDeskwithoutPriceOverRide ? 'flex-start' : 'flex-end'};
    text-align: left;
    ${media.mobileDevice`
        align-self: flex-start;
        width: 170px;
        margin-left: 8%
    `}
`;

export const AddSignatureWrapper = styled.div`
    display: block;
    padding: 15px 20px;
`;
